(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_blog-post-content"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('blog-post-table-of-contents')) {
    customElements.define('blog-post-table-of-contents', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;

        this.content = document.getElementById(this.dataset.contentId);
        this.lists = Array.from(this.querySelectorAll('[data-toc-list]'));
        this.drawer = this.querySelector('[data-toc-dialog]');
        this.openButton = this.querySelector('[data-toc-open]');
        this.closeButton = this.querySelector('[data-toc-close]');

        if (!this.content || this.lists.length === 0) return;

        this.headings = Array.from(this.content.querySelectorAll('h2, h3')).filter(
          (heading) => heading.textContent.trim().length > 0
        );
        if (this.headings.length < 2) return;

        this.assignHeadingIds();
        this.lists.forEach((list) => this.buildList(list));
        this.bindDrawer();
        this.observeHeadings();

        this.closest('.blog-post-content-block')?.classList.add('blog-post-content-block--has-toc');
        this.dataset.ready = 'true';
        this.hidden = false;

        if (window.location.hash) {
          let requestedId = window.location.hash.slice(1);
          try {
            requestedId = decodeURIComponent(requestedId);
          } catch (error) {
            requestedId = window.location.hash.slice(1);
          }

          const requestedHeading = document.getElementById(requestedId);
          if (requestedHeading && this.headings.includes(requestedHeading)) {
            requestAnimationFrame(() => requestedHeading.scrollIntoView({ block: 'start' }));
          }
        }
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.mobileMedia?.removeEventListener('change', this.handleViewportChange);
      }

      assignHeadingIds() {
        const headingSet = new Set(this.headings);
        const usedIds = new Set(
          Array.from(document.querySelectorAll('[id]'))
            .filter((element) => !headingSet.has(element))
            .map((element) => element.id)
            .filter(Boolean)
        );

        this.headings.forEach((heading, index) => {
          const text = heading.textContent.trim();
          const baseId = heading.id.trim() || this.createSlug(text, index);
          let headingId = baseId;
          let suffix = 2;

          while (usedIds.has(headingId)) {
            headingId = `${baseId}-${suffix}`;
            suffix += 1;
          }

          heading.id = headingId;
          usedIds.add(headingId);
        });
      }

      buildList(list) {
        let currentParentItem = null;

        this.headings.forEach((heading) => {
          const item = document.createElement('li');
          item.className = 'blog-post-toc__item';

          const link = document.createElement('a');
          link.className = 'blog-post-toc__link';
          link.href = `#${heading.id}`;
          link.dataset.targetId = heading.id;
          link.textContent = heading.textContent.trim();
          link.addEventListener('click', (event) => this.navigateToHeading(event, heading));

          item.appendChild(link);

          if (heading.tagName.toLowerCase() === 'h3' && currentParentItem) {
            let sublist = currentParentItem.querySelector('.blog-post-toc__sublist');
            if (!sublist) {
              sublist = document.createElement('ul');
              sublist.className = 'blog-post-toc__sublist';
              currentParentItem.appendChild(sublist);
            }
            sublist.appendChild(item);
          } else {
            list.appendChild(item);
            currentParentItem = heading.tagName.toLowerCase() === 'h2' ? item : null;
          }
        });
      }

      bindDrawer() {
        if (!this.drawer || !this.openButton || !this.closeButton) return;

        this.openButton.addEventListener('click', () => {
          this.drawer.showModal();
          this.openButton.setAttribute('aria-expanded', 'true');
          this.closeButton.focus();
        });

        this.closeButton.addEventListener('click', () => this.drawer.close());
        this.drawer.addEventListener('close', () => {
          this.openButton.setAttribute('aria-expanded', 'false');
        });
        this.drawer.addEventListener('click', (event) => {
          if (event.target === this.drawer) this.drawer.close();
        });

        this.mobileMedia = window.matchMedia('(max-width: 989px)');
        this.handleViewportChange = (event) => {
          if (!event.matches && this.drawer.open) this.drawer.close();
        };
        this.mobileMedia.addEventListener('change', this.handleViewportChange);
      }

      navigateToHeading(event, heading) {
        event.preventDefault();
        window.history.pushState(null, '', `#${encodeURIComponent(heading.id)}`);
        this.setActiveHeading(heading.id);

        const moveToHeading = () => {
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
              heading.scrollIntoView({ behavior, block: 'start' });
              if (!heading.hasAttribute('tabindex')) heading.setAttribute('tabindex', '-1');
              heading.focus({ preventScroll: true });
            });
          });
        };

        if (this.drawer?.open) {
          this.drawer.close();
          window.setTimeout(moveToHeading, 100);
        } else {
          moveToHeading();
        }
      }

      observeHeadings() {
        if (!('IntersectionObserver' in window)) return;

        this.observer = new IntersectionObserver((entries) => {
          const visibleHeading = entries
            .filter((entry) => entry.isIntersecting)
            .sort((first, second) => first.boundingClientRect.top - second.boundingClientRect.top)[0];

          if (visibleHeading) this.setActiveHeading(visibleHeading.target.id);
        }, {
          rootMargin: '-15% 0px -70% 0px',
          threshold: 0
        });

        this.headings.forEach((heading) => this.observer.observe(heading));
      }

      setActiveHeading(headingId) {
        this.querySelectorAll('[data-target-id]').forEach((link) => {
          if (link.dataset.targetId === headingId) {
            link.setAttribute('aria-current', 'true');
          } else {
            link.removeAttribute('aria-current');
          }
        });
      }

      createSlug(text, index) {
        const slug = text
          .normalize('NFKD')
          .toLowerCase()
          .trim()
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/[^\p{L}\p{N}\s-]/gu, '')
          .replace(/\s+/g, '-')
          .replace(/-+/g, '-')
          .replace(/^-|-$/g, '');

        return slug || `section-${index + 1}`;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
